<div class="close-dialog-holder">
  <button
    mat-icon-button
    mat-dialog-close
    type="button"
    class="close-dialog-button">
    <mat-icon>clear</mat-icon>
  </button>
</div>
<form [formGroup]="form" (ngSubmit)="submit()">
  @if (promisedPayment) {
    <p class="closing-date-description">
      {{
        'change-closing-date.component.adjust_closing_date_or_set_new_payment'
          | localise
            : 'Adjust your closing date or set a new payment date here. The amount you' +
                'owe may change with the dates.'
      }}
    </p>
    <p>
      <strong>
        {{
          (promisedPaymentPreview | totalByPromisedList) ||
            promisedPayment.total | currencyJs: { showSymbol: true }
        }}
        due
      </strong>
    </p>
  }

  @if (promisedPaymentPreview) {
    <mat-divider></mat-divider>
    <p>
      <strong>{{
        'change-closing-date.component.you_should_pay'
          | localise: 'You should pay:'
      }}</strong>
    </p>
    @for (payment of promisedPaymentPreview; track payment) {
      <p>
        {{ payment.effectiveDate | dateApp: formatDateEnum.MMDDYYYY : true }}:
        {{ payment.total | currencyJs: { showSymbol: true } }}
      </p>
    }
  }

  @if (promisedPayment) {
    <mat-divider></mat-divider>
  }

  <mat-dialog-content>
    <div class="dates__closing">
      <h3>
        {{
          'change-closing-date.component.closing_date'
            | localise: 'Closing Date'
        }}
      </h3>
      @if (closingDateMin) {
        <mat-calendar
          [minDate]="closingDateMin"
          [selected]="form.controls.closingDate.value"
          (selectedChange)="form.controls.closingDate.setValue($event)">
        </mat-calendar>
      }
    </div>

    @if (
      form.controls.closingDate.value
        | isMoreDays: deal.closingDate : maxDiffClosingDate
    ) {
      <div class="upload-document">
        @if (!form.controls.userDealDocumentId.value) {
          <p class="addendum-doc-explain">
            {{
              'change-closing-date.component.upload_extension_or_addendum_for_listing'
                | localise
                  : 'Please upload the extension/addendum for this listing'
            }}
          </p>
          <mat-form-field appearance="fill">
            <mat-label
              >{{
                'change-closing-date.component.description'
                  | localise: 'Description'
              }}
            </mat-label>
            <textarea
              matInput
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="descriptionForClosingDate"></textarea>
          </mat-form-field>
          @if (loadingFile) {
            <mat-spinner [diameter]="22"></mat-spinner>
          }
          <label class="upload-document" [class.hidden]="loadingFile">
            {{
              'change-closing-date.component.upload_document'
                | localise: 'Upload Document'
            }}
            <input
              #inputFile
              type="file"
              accept=".pdf,.doc,.docx,.dot,.dotx,.docm,.dotm"
              ngFileSelect
              [options]="options"
              (uploadOutput)="
                onUploadOutput(
                  $event,
                  userDealDocumentDocumentTypeEnum.ExpansionAddendum,
                  descriptionForClosingDate
                )
              "
              [uploadInput]="uploadInput" />
            <button mat-button type="button" (click)="inputFile.click()">
              {{
                'change-closing-date.component.choose_file'
                  | localise: 'Choose File'
              }}
            </button>
            <label>
              {{
                'change-closing-date.component.no_file_chosen'
                  | localise: 'No file chosen'
              }}
            </label>
          </label>
        } @else {
          <span class="document-is-uploaded">
            <div>
              {{
                'change-closing-date.component.document_is_uploaded'
                  | localise: 'Document is uploaded'
              }}
            </div>
            <mat-icon class="material-icons-outlined" color="accent"
              >check_circle</mat-icon
            >
          </span>
        }
      </div>
    }

    @if (error) {
      @switch (error) {
        @case ('Only one closing date change is allowed') {
          <p
            class="p-error-message p-error-message--margin only-one-closing-date-change">
            {{
              'change-closing-date.component.only_one_closing_date_change_allowed'
                | localise: 'Only one closing date change is allowed.'
            }}<br />
            {{
              'change-closing-date.component.if_need_change_closing_date_contact'
                | localise
                  : 'If you need to change the closing date, please contact'
            }}
            <a href="mailto:{{ sharedService.companyEmail }}">{{
              sharedService.companyEmail
            }}</a>
            {{ 'change-closing-date.component.or_call' | localise: 'or call' }}
            <a href="tel:{{ sharedService.companyPhone }}">{{
              sharedService.companyPhoneFormatted
            }}</a>
          </p>
        }
        @default {
          <p
            class="p-error-message p-error-message--margin only-one-closing-date-change">
            {{ error }}
          </p>
        }
      }
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      mat-button
      [mat-dialog-close]="false"
      class="dialog-button"
      type="button">
      {{ 'change-closing-date.component.cancel_button' | localise: 'Cancel' }}
    </button>
    <button
      mat-button
      cdkFocusInitial
      class="dialog-button dialog-button--primary"
      type="submit">
      {{ 'change-closing-date.component.update_button' | localise: 'Update' }}
    </button>
  </mat-dialog-actions>
</form>
